import {useParams} from 'react-router-dom';

import {isNil} from 'ramda';

import {useGetTireCategoryQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {TireCategoryDetailForm} from './components/TireCategoryDetailForm';

export function TireInventoryCategoryDetail() {
  const {id} = useParams();

  const tireCategoryQuery = useGetTireCategoryQuery({tireCategoryId: id ?? ''}, {skip: isNil(id)});

  return (
    <SettingsTemplate
      header={{
        title:
          tireCategoryQuery.data?.name ?? i18n.t('entity.tiresInventory.labels.newTireCategory'),
        breadcrumbs: [
          {
            label: i18n.t('module.tiresInventory.title'),
            isCurrentPage: true,
          },
          {
            label: i18n.t('entity.tiresInventory.labels.tireCategory'),
            href: settingsRoutes.tireCategory,
          },
        ],
      }}
      isLoading={tireCategoryQuery.isLoading}
      isError={tireCategoryQuery.isError}
      isCreating={isNil(id)}
      data-testid={testIds.settings.tireCategoryDetail('template')}
    >
      <TireCategoryDetailForm tireCategory={tireCategoryQuery.data} />
    </SettingsTemplate>
  );
}
